import { Dictionary } from '../../../../types/globals';
import { BrandActionsTypes, BrandData, BrandsAction, BrandsResponseFromApi, BrandsState } from './types';

const defaultBrandState: BrandsState = {
    brands: [],
    brandEntities: {},
};

export const mapBrands = (acc: {}, brand: BrandsResponseFromApi): Dictionary<string> => {
    return {
        ...acc,
        [brand.url_key]: brand.id_catalog_brand,
    };
};

export const mapApiBrandsToBellaNaming = (brand: BrandsResponseFromApi): BrandData => {
    return {
        name: brand.name,
        urlKey: brand.url_key,
        catalogBrandId: brand.id_catalog_brand,
    };
};

const brandsReducer = (state: BrandsState = defaultBrandState, action: BrandsAction): BrandsState => {
    switch (action.type) {
        case BrandActionsTypes.RESPONSE: {
            return {
                ...state,
                brands: (action.response.data || []).map(mapApiBrandsToBellaNaming) || [],
                brandEntities: (action.response.data || []).reduce(mapBrands, {}),
            };
        }
        default: {
            return state;
        }
    }
};

export default brandsReducer;
